import { INSIGHTS_LOADING_ENTER_RAF_FRAMES } from "../insightsLoading.constants";

export const runAfterEnterRafFrames = (onComplete: () => void): (() => void) => {
    let frame = 0;
    let rafId = 0;

    const tick = () => {
        frame += 1;

        if (frame >= INSIGHTS_LOADING_ENTER_RAF_FRAMES) {
            onComplete();
            return;
        }

        rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);

    return () => cancelAnimationFrame(rafId);
};
